import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillContainer, TrlPillLabel } from '../TrlPill.styles';
import { TrlPillRejectedStyled } from './TrlPillRejected.styles';

export const TrlPillRejected = () => {
  return (
    <TrlPillContainer>
      <TrlPillRejectedStyled />
      <TrlPillLabel>
        <FormattedMessage id="TRLT_UI-REJECTED" />
      </TrlPillLabel>
    </TrlPillContainer>
  );
};
